const ALLCOLORS = [
  '#B35511',
  '#983111',
  '#CF001F',
  '#A6004B',
  '#88003D',
  '#BC7234',
  '#F78221',
  '#F15E44',
  '#FF2949',
  '#EF006C',
  '#900070',
  '#CF9F00',
  '#FFCA1B',
  '#FCBA80',
  '#FF8A8E',
  '#FE7FB4',
  '#FF5CD5',
  '#B92492',
  '#C7CB14',
  '#ECF01A',
  '#FFF775',
  '#FADDBF',
  '#FFBED9',
  '#F99CF7',
  '#C04BF8',
  '#8921BB',
  '#82D664',
  '#A5FF85',
  '#CCFFA2',
  '#E2FCC5',
  '#FFFFFF',
  '#E0C7FF',
  '#B676FF',
  '#8500FF',
  '#490B83',
  '#57C743',
  '#77F860',
  '#97FFA0',
  '#C3FEE2',
  '#C3E0FE',
  '#7A88FF',
  '#634BFF',
  '#6500C3',
  '#35A421',
  '#44E079',
  '#7BFFC4',
  '#88FFF7',
  '#65D1FF',
  '#268AFF',
  '#4C37D0',
  '#02812D',
  '#22D39E',
  '#51DECD',
  '#53E6FA',
  '#12B8EC',
  '#00489D',
  '#01583E',
  '#1A8867',
  '#3CA195',
  '#00899B',
  '#005773',
];
export { ALLCOLORS };
